import { MutableRefObject, useLayoutEffect, useRef } from 'react';

/** A ref to the value of the latest render, for callbacks that run later (not during render). */
export function useLatestRef<T>(value: T): Readonly<MutableRefObject<T>> {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
